import React, { useCallback, useState } from 'react';

import { Alert, App, Button, Checkbox, Modal, Typography } from 'antd';

import configAPIService from 'v2/services/configAPI';

interface IProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const NewApiKeyDialog = ({ open, onClose, onConfirm }: IProps) => {
  const { message } = App.useApp();
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);

  const updateKey = useCallback(async () => {
    setLoading(true);
    configAPIService.updateApiKey().subscribe(
      () => {
        message.success('API key atualizada com sucesso');
        setLoading(false);
        setAccepted(false);
        onConfirm();
      },
      error => {
        message.error(typeof error === 'string' ? error : 'Não foi possível gerar uma nova API key.');
        setLoading(false);
      }
    );
  }, [message, onConfirm]);

  return (
    <Modal
      title='Atenção'
      open={open}
      width={600}
      onCancel={onClose}
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='text' onClick={onClose} disabled={loading}>
            Não, quero manter a API key
          </Button>
          <Button danger loading={loading} type='primary' disabled={loading || !accepted} onClick={updateKey}>
            Sim, gerar uma nova API key
          </Button>
        </div>
      }
    >
      <div className='flex flex-col gap-4'>
        <Alert
          type='warning'
          showIcon
          message={
            <>
              Você está a um passo de executar{' '}
              <Typography.Text strong>UMA AÇÃO QUE NÃO PODE SER DESFEITA</Typography.Text>.
            </>
          }
        />

        <div className='flex flex-col gap-3 rounded-(--uizz-antd-border-radius-lg) bg-(--uizz-antd-color-fill-tertiary) p-4'>
          <Typography.Paragraph className='mb-0'>
            Ao gerar uma nova API Key, todas as suas integrações com a nossa API deixarão de funcionar. Fique atento às
            recomendações abaixo:
          </Typography.Paragraph>
          <ul className='mb-0 list-disc pl-5'>
            <li>
              Antes de gerar uma nova API Key, identifique todos os sistemas que integram com a Eduzz através da nossa
              API;
            </li>
            <li>
              Realize essa operação em um horário de menor fluxo para sua operação, por exemplo, durante a madrugada, o
              impacto tende a ser menor;
            </li>
            <li>Após gerar uma nova API Key, informe-a em todos os seus sistemas que integram com a Eduzz;</li>
            <li>
              Anote a nova API Key que será gerada em um local seguro,{' '}
              <Typography.Text strong>
                ELA SÓ ESTARÁ DISPONÍVEL NESTA TELA, NO MOMENTO DA GERAÇÃO E NÃO SERÁ SALVA EM NENHUM OUTRO LOCAL
              </Typography.Text>
              .
            </li>
          </ul>
          <Checkbox checked={accepted} onChange={e => setAccepted(e.target.checked)}>
            Li e entendi todas as recomendações acima.
          </Checkbox>
        </div>
      </div>
    </Modal>
  );
};
